import React, { useState } from 'react';

const MapaIndicador = ({ valor }) => {
    const [hoveredValue, setHoveredValue] = useState(null);
    const valorNormalizado = Math.min(Math.max(valor || 0, 0), 9);

    const posicaoPorcentagem = (valorNormalizado / 9) * 100;

    const getCorPorValor = (val) => {
        if (val <= 4) {
            const ratio = val / 4;
            const r = Math.round(34 + (234 - 34) * ratio);
            const g = Math.round(197 + (179 - 197) * ratio);
            const b = Math.round(94 + (9 - 94) * ratio);
            return `rgb(${r}, ${g}, ${b})`;
        } else {
            const ratio = (val - 4) / 4;
            const r = Math.round(234 + (239 - 234) * ratio);
            const g = Math.round(179 + (68 - 179) * ratio);
            const b = Math.round(9 + (68 - 9) * ratio);
            return `rgb(${r}, ${g}, ${b})`;
        }
    };

    const segmentos = [];
    const descricoes = {
        0: 'Sem relaxamento',
        1: 'Relaxamento de portifólios correlatos',
        2: 'Relaxamento de portifólios correlatos + iniciativas tecnológicas correlatas',
        3: 'Relaxamento de portifólios correlatos + um grau de inovação + iniciativas tecnológicas correlatas',
        4: 'Relaxamento de portifólios correlatos + todos os graus de inovação + iniciativas tecnológicas correlatas',
        5: 'Relaxamento de todas as iniciativas tecnológicas',
        6: 'Relaxamento de portifólios correlatos + todas as iniciativas tecnológicas',
        7: 'Relaxamento de portifólios correlatos + um grau de inovação + todas as iniciativas tecnológicas',
        8: 'Relaxamento de portifólios correlatos + todos os graus de inovação + todas as iniciativas tecnológicas',
        9: 'Relaxamento de todos os portifólios + todos os graus de inovação + todas as iniciativas tecnológicas'
    };

    for (let i = 0; i <= 9; i++) {
        segmentos.push({
            valor: i,
            cor: getCorPorValor(i),
            descricao: descricoes[i]
        });
    }

    return (
        <div className="flex flex-col items-center py-1" style={{ width: '50%', margin: '0 auto' }}>
            {/* Título acima da barra */}
            <div className="text-xs font-semibold text-gray-600 mb-1 uppercase tracking-wide text-center">
                Escala do relaxamento de filtros
            </div>

            {/* Barra horizontal */}
            <div
                className="relative overflow-hidden w-full"
                style={{
                    height: '16px',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    background: `linear-gradient(to right,
                        rgb(34, 197, 94) 0%,
                        rgb(84, 192, 73) 12.5%,
                        rgb(134, 188, 51) 25%,
                        rgb(184, 183, 30) 37.5%,
                        rgb(234, 179, 8) 50%,
                        rgb(235, 151, 23) 62.5%,
                        rgb(237, 124, 38) 75%,
                        rgb(238, 96, 53) 87.5%,
                        rgb(239, 68, 68) 100%)`
                }}
            >
                {/* Marcações de escala - linhas verticais */}
                {segmentos.map((seg) => (
                    <div
                        key={seg.valor}
                        className="absolute h-full"
                        style={{
                            left: `${(seg.valor / 9) * 100}%`,
                            width: '1px',
                            backgroundColor: 'rgba(255, 255, 255, 0.4)'
                        }}
                    />
                ))}

                {/* Indicador do valor atual - linha vertical */}
                <div
                    className="absolute h-full transition-all duration-300"
                    style={{
                        left: `${posicaoPorcentagem}%`,
                        transform: 'translateX(-50%)'
                    }}
                >
                    <div
                        style={{
                            width: '3px',
                            height: '100%',
                            backgroundColor: '#1f2937',
                            boxShadow: '0 0 4px rgba(0,0,0,0.5)'
                        }}
                    >
                        {/* Seta indicadora abaixo */}
                        <div
                            style={{
                                position: 'absolute',
                                bottom: '-5px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: 0,
                                height: 0,
                                borderLeft: '5px solid transparent',
                                borderRight: '5px solid transparent',
                                borderTop: '5px solid #1f2937'
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Labels da escala abaixo */}
            <div className="w-full mt-1">
                <div className="relative w-full flex justify-between">
                    {segmentos.map((seg) => (
                        <div
                            key={seg.valor}
                            className="relative flex flex-col items-center cursor-help"
                            onMouseEnter={() => setHoveredValue(seg.valor)}
                            onMouseLeave={() => setHoveredValue(null)}
                        >
                            <span
                                style={{
                                    fontSize: '11px',
                                    fontWeight: seg.valor === Math.round(valorNormalizado) ? '700' : '400',
                                    color: seg.valor === Math.round(valorNormalizado) ? '#1f2937' : '#9ca3af',
                                    lineHeight: '1'
                                }}
                            >
                                {seg.valor}
                            </span>

                            {/* Tooltip acima */}
                            {hoveredValue === seg.valor && (
                                <div
                                    className="absolute bg-gray-800 text-white text-xs rounded px-3 py-2 z-50 shadow-lg"
                                    style={{
                                        bottom: '20px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        minWidth: '200px',
                                        maxWidth: '250px',
                                        whiteSpace: 'normal'
                                    }}
                                >
                                    {seg.descricao}
                                    {/* Seta apontando para baixo */}
                                    <div
                                        style={{
                                            position: 'absolute',
                                            left: '50%',
                                            bottom: '-4px',
                                            transform: 'translateX(-50%)',
                                            width: 0,
                                            height: 0,
                                            borderLeft: '4px solid transparent',
                                            borderRight: '4px solid transparent',
                                            borderTop: '4px solid #1f2937'
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MapaIndicador;
